import { createContext } from 'react';

export const UserContext = createContext("");

export const PostContext = createContext("");

export const UserPostsContext = createContext("");